var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-rule-tab"},[_c('RuleConditions',{staticClass:"conditions",attrs:{"sync":""}}),_c('RuleAction',{attrs:{"sync":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }